import styled from "styled-components";
import { ChipStylesVariantType } from "../../types";

type ChipStylesType = {
  styles: ChipStylesVariantType;
};

export const ChipContainer = styled.div<ChipStylesType>`
  border: 1px solid ${(props) => props.styles.border};
  border-radius: 1rem;
  color: ${(props) => props.styles.color};
  background: ${(props) => props.styles.background};
  display: inline-flex;
  align-items: center;
  padding: 0.5rem;
`;
